import { km } from './km'
import type { ErrorCode } from '../api/request'

/**
 * 一期只有高棉文。留这层间接是为了后面加语言时不用改调用方，
 * 但**不做过度设计**——没有 provider、没有插值引擎，就是一个常量表。
 */
export const t = km

/** 错误码 → 高棉文。code 是枚举，漏一个类型检查就会报。 */
export function errorText(code: ErrorCode | 'unknown' | 'outsideTelegram'): string {
  return t.error[code] ?? t.error.unknown
}
